import { render, staticRenderFns } from "./iconArrowDown.vue?vue&type=template&id=66fc7c91"
import script from "./iconArrowDown.vue?vue&type=script&lang=js"
export * from "./iconArrowDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports